import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { financialyearservice } from "@/api/services/accountService";

interface FinancialYear {
  id: string;
  finYearCode: string;
  dateFrom: string;
  dateTo: string;
  closed: boolean;
  closedOn: string;
  closedUserId: string;
}

interface FinancialYearState {
  selectedFinYear?: FinancialYear | null;
  FinancialYearList: FinancialYear[];
  loading: boolean;
  error: string | null;
}

const storedFinYear = localStorage.getItem("selectedFinYear");

const initialState: FinancialYearState = {
  selectedFinYear: storedFinYear ? JSON.parse(storedFinYear) : null,
  FinancialYearList: [],
  loading: false,
  error: null,
};

export const fetchFinancialYear = createAsyncThunk<
  FinancialYear[],
  void,
  { rejectValue: string }
>("FinancialYear/fetchFinancialYear", async (_, { rejectWithValue }) => {
  try {
    const response = await financialyearservice.getall();
    // If API returns { data: financial year[] }, extract `data`
    return response?.data?.financialYearDatas;
  } catch (error: any) {
    return rejectWithValue(error.message || "Failed to fetch Financial Years");
  }
});

const financialyearSlice = createSlice({
  name: "FinancialYear",
  initialState,
  reducers: {
    setSelectedFinYear: (state, action: PayloadAction<FinancialYear>) => {
      state.selectedFinYear = action.payload;
      localStorage.setItem("selectedFinYear", JSON.stringify(action.payload));
    },
    clearSelectedFinYear: (state) => {
      state.selectedFinYear = null;
      localStorage.removeItem("selectedFinYear");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFinancialYear.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFinancialYear.fulfilled, (state, action: PayloadAction<FinancialYear[]>) => {
        state.loading = false;
        state.FinancialYearList = action.payload;
      })
      .addCase(fetchFinancialYear.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setSelectedFinYear, clearSelectedFinYear } = financialyearSlice.actions;
export default financialyearSlice.reducer;
